import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { QuodinHome } from './QuodinHome';

/**
 * Replaces the stock Backstage home with the Quodin landing page. Registered
 * under the `home` plugin at `/` — the catalog moves back to `/catalog` in
 * app-config so this page owns the root route.
 */
const quodinHomePage = PageBlueprint.make({
  name: 'quodin',
  params: {
    path: '/',
    loader: async () => <QuodinHome />,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [quodinHomePage],
});
